

export const Text = {}